<template>
  <div class="home-sider" ref="sider">
    <div class="box">
      <ul>
        <li v-for="(item, index) in menuList" v-show="item.needPassportType.indexOf(passportType) > -1" ref="liStyle"
          :key="index">
          <router-link :to="item.path" v-if="item.title != '安全中心客户端' && item.title != '调试模式'">
            <div class="icon">
              <img :src="item.icon" />
            </div>
            <div class="title" v-text="item.title"></div>
          </router-link>
          <router-link :to="item.path" v-if="item.title == '安全中心客户端'" v-show="$store.state.user.isCanUseClient">
            <div class="icon">
              <img :src="item.icon" />
            </div>
            <div class="title" v-text="item.title"></div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import PAGE_API from '@/apis/pageApi'

import barManagerIcon from '@/assets/img/icon/w1.png'
import staffManageIcon from '@/assets/img/icon/y1.png'
// import messageBoardIcon from '@/assets/img/icon/m1.png'
import accountSafeIcon from '@/assets/img/icon/z1.png'
import operationLogIcon from '@/assets/img/icon/c1.png'
import securityCenterIcon from '@/assets/img/icon/u521.png'
import threeTierMissionIcon from '@/assets/img/icon/renwu.png'
import download from '@/assets/img/icon/down.png'
import { mapState } from 'vuex'

export default {
  name: 'homeSider',
  data () {
    return {
      menuList: [
        // 网吧管理
        {
          path: PAGE_API.home.children.barManager,
          title: PAGE_API.home.children.barManager.title,
          icon: barManagerIcon,
          needPassportType: [0, 2, 3],
        },
        // 主动防御
        {
          path: PAGE_API.home.children.securityCenter.path,
          title: PAGE_API.home.children.securityCenter.title,
          icon: securityCenterIcon,
          needPassportType: [0, 2, 3],
        },
        // 三层任务
        {
          path: PAGE_API.home.children.threeTierMission.path,
          title: PAGE_API.home.children.threeTierMission.title,
          icon: threeTierMissionIcon,
          needPassportType: [0, 2, 3],
        },
        // 员工管理
        {
          path: PAGE_API.home.children.staffManage.path,
          title: PAGE_API.home.children.staffManage.title,
          icon: staffManageIcon,
          needPassportType: [0],
        },
        // 网吧留言板
        // {
        //     path: PAGE_API.home.children.messageBoard.path,
        //     title: PAGE_API.home.children.messageBoard.title,
        //     icon: messageBoardIcon,
        //     needPassportType:[0,2,3]
        // },
        // 账号安全
        {
          path: PAGE_API.home.children.accountSafe.path,
          title: PAGE_API.home.children.accountSafe.title,
          icon: accountSafeIcon,
          needPassportType: [0, 2, 3],
        },
        // 操作日志
        {
          path: PAGE_API.home.children.operationLog.path,
          title: PAGE_API.home.children.operationLog.title,
          icon: operationLogIcon,
          needPassportType: [0, 2, 3],
        },
        // {
        //   path: PAGE_API.home.children.download.path,
        //   title: PAGE_API.home.children.download.title,
        //   icon: download,
        //   needPassportType: [0, 2, 3],
        // },
        {
          path: PAGE_API.home.children.debugModel.path,
          title: PAGE_API.home.children.debugModel.title,
          needPassportType: [0, 2, 3],
        },
      ],
    }
  },
  mounted () {
    // this.$domFn.addAnimateClass(this.$refs.sider, 'animated fadeInLeftBig')
  },
  computed: {
    ...mapState({
      passportType: (state) => state.user.userInfo.passportType,
    }),
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '_style/_color.scss';
$li-height: 40px;

.home-sider {
  position: absolute;
  width: 60px;
  line-height: 45px;
  padding-top: 0px;
  top: 0;
  bottom: 0;
  background: $black-bg;
  color: $white-word;
  overflow: hidden;
  transition: all 0.2s;
  z-index: 80;
}

.box {
  border-top: 1px solid #525252;

  ul {
    width: 100%;
    text-align: left;
    padding-top: 10px;
  }

  li {
    height: $li-height;
    cursor: pointer;

    a {
      display: block;
      height: $li-height;
      overflow: hidden;
      color: #fff;
      transition: all 0.3s;

      &:hover {
        background: #191d21;
        color: #fff;
      }

      &.router-link-active {
        background: $cyan;
      }
    }

    .icon {
      float: left;
      padding-top: 4px;
      margin-top: 0px;
      width: 60px;
      text-align: center;

      img {
        width: 16px;
      }
    }

    .title {
      float: left;
      margin-top: 0px;
      text-align: left;
    }
  }
}
</style>
